import { render, staticRenderFns } from "./SocialRewardsCreateCampaign.vue?vue&type=template&id=34b1271f&scoped=true&"
import script from "./SocialRewardsCreateCampaign.vue?vue&type=script&lang=ts&"
export * from "./SocialRewardsCreateCampaign.vue?vue&type=script&lang=ts&"
import style0 from "./SocialRewardsCreateCampaign.vue?vue&type=style&index=0&id=34b1271f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b1271f",
  null
  
)

export default component.exports